import { create } from "zustand";
import { authFetch } from "../utils/apiClient.js";
import { sendEmailVerification } from "firebase/auth";

const useApiStore = create((set, get) => ({
  sendVerificationEmail: async (user) => {
    try {
      await sendEmailVerification(user);
    } catch (error) {
      const errorCode = error.code;
      if (errorCode === 'auth/too-many-requests') {
        return 'errors.tooManyRequests'
      } else {
        return 'errors.failedToSendEmail'
      }
    }
  }
}));

export default useApiStore;
